module.exports = __webpack_public_path__ + "img/startCircle.527bd548.svg";